export const validateVarname = (value: string) => {
  const startsWithInvalidChar = /^[0-9_-]/;

  const regex = /^[a-zA-Z][a-zA-Z0-9_-]*$/;

  if (startsWithInvalidChar.test(value)) {
    return "FORM_BUILDER.QUESTION_PROPERTIES.ERROR_VAR_NAME_STARTS_WITH_ALPHABET";
  } else if (!regex.test(value)) {
    return "FORM_BUILDER.QUESTION_PROPERTIES.ERROR_VAR_NAME_ALLOWED_CHARS";
  }
  return "";
};
